import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PageService } from '../state/page/page.service';
import {environment} from '@env/environment';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private _pageService: PageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(environment.workerRoot)) {
      req = req.clone({
        withCredentials: false
      });
    } else {
      req = req.clone({
        withCredentials: false,
        setHeaders: {
          Authorization: `Basic bmR2aUNsaWVudDpLJCFLZDQ2SCRyUXVoV1FaIA==`
        }
      });
    }

    this._pageService.setLoading(true);
    return next
      .handle(req)
      .pipe(
        finalize(() => {
          this._pageService.setLoading(false);
        })
      );
  }
}
